/**
 * Algonomy Personalization Process API Requests.
 * This module contains functions to facilitate communication with the Algonomy personalization server.
 * The purpose is to send user behavior data to the Algonomy server in listen mode, allowing the accumulation of data for our customers. 
 * Once sufficient data is collected, the Algonomy server will provide personalized data for our logged-in users, enhancing the user experience on our website.
 */
import { get } from "../utility/apiClient";
import { store } from '../redux/store';
import { updateAlgonomyRcs } from '../redux/actions/algonomyActions';

//done
export function algonomyHomePageRequest(outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/HomePage?rcs=${rcs}&rid=${outletCode}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy Home Page Request', response.data.errorList[0].statusMessage)
        }
    })
};

//done
export function algonomySearchPageRequest(searchTerm, outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/SearchPage?rcs=${rcs}&rid=${outletCode}&searchTerm=${searchTerm}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy Search Page Request', response.data.errorList[0].statusMessage)
        }
    })
};

/**
 * Date     :   2023-09-18
 * Author   :   Gayani Nishadika
 * Remarks  :   Algonomy development
 */

//done
export function algonomyCategoryPageRequest(categoryId, outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/CategoryPage?rcs=${rcs}&rid=${outletCode}&categoryId=${categoryId}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy category Page Request', response.data.errorList[0].statusMessage)
        }
    })
};

//done
export function algonomyAddToCartPageRequest(itemCode, outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/AddToCartPage?rcs=${rcs}&rid=${outletCode}&atcid=${itemCode}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy add to cart Page Request', response.data.errorList[0].statusMessage)
        }
    })
};

//done
export function algonomyItemPageRequest(itemCode, outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/ItemPage?rcs=${rcs}&rid=${outletCode}&productId=${itemCode}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy item Page Request', response.data.errorList[0].statusMessage)
        }
    })
};
//done
export function algonomyCartPageRequest(cartItemIds, outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/CartPage?rcs=${rcs}&rid=${outletCode}&productId=${cartItemIds}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy cart Page Request', response.data.errorList[0].statusMessage)
        }
    })
};
//done
export function algonomyPurchaseCompletePageRequest(itemCodes, orderId, quantity, productPrice, outletCode) {
    const state = store.getState();
    const rcs = state.algonomyData.rcs;
    get(`/Algonomy/PurchaseCompletePage?rcs=${rcs}&rid=${outletCode}&productId=${itemCodes}&o=${orderId}&q=${quantity}&pp=${productPrice}`).then(response => {
        if (response.data.statusCode === 200) {
            if (response.data.result.status === "ok") {
                store.dispatch(updateAlgonomyRcs({ rcs: response.data.result.rcs }));
            }
        } else {
            console.error('Algonomy purchase complete Page Request', response.data.errorList[0].statusMessage)
        }
    })
};